import { Component, OnInit, NgZone } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalProductoDetalleComponent } from '../../componentes/modal-producto-detalle/modal-producto-detalle.component';
import { ModalFiltroModelosComponent } from '../../componentes/modal-filtro-modelos/modal-filtro-modelos.component';
import { ModalFiltroTagsComponent } from '../../componentes/modal-filtro-tags/modal-filtro-tags.component';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { MdcSnackbar } from '@angular-mdc/web';
import { ChangeDetectorRef } from '@angular/core';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-catalogo-listado',
  templateUrl: './catalogo-listado.component.html',
  styleUrls: ['./catalogo-listado.component.scss']
})
export class CatalogoListadoComponent implements OnInit {
	firstTime = false;
	cargoListaAnterior = false
	params=null;
	constructor(
		public globals: Globals,
		private fb: FormBuilder,
		private productoService: ProductoService,
		private activatedRoute: ActivatedRoute,
		public clipboard: Clipboard,
		public dialog: MatDialog,
		private snackBar: MdcSnackbar,
		private router: Router,

	) { 

		
	}

	feedProductos = {
		cargando: true,
		productos: new Array(),
		paginaActual: 1,
	}

	formSearch = this.fb.group({
		busqueda:[
			this.globals.configuracion.front.listado.busqueda
		]
	});
	// 
  ordenarListado( ordenar, ordenar_modo ){
	this.formSearch.controls.busqueda.setValue("");
	this.globals.configuracion.front.listado.tag = "";
	this.globals.configuracion.front.listado.tag_descripcion = "";

	this.globals.configuracion.front.listado.ordenar_new = ordenar;
	this.globals.configuracion.front.listado.ordenar_modo = ordenar_modo;
	
	this.search();
  }

  search(){
	
	this.globals.configuracion.front.listado.busqueda = this.formSearch.controls.busqueda.value;
	this.globals.setDataFront();

    this.feedProductos.productos.splice( 0 );

    this.feedProductos.paginaActual = parseInt(localStorage.getItem("paginaActual")) || 1;

    this.productosListado();
  }

  productosListado(){
	let pagina;
    this.feedProductos.cargando = true;
	// console.log('this.firstTime',this.firstTime)
	if(localStorage.getItem("paginaActual") != null && localStorage.getItem("popstate") != null && localStorage.getItem("popstate") == 'true'){
		// alert("aqui viene de afuera que se salio")
		pagina = localStorage.getItem("paginaActual")
		console.log('seteando pagina malditoa1',pagina)
		localStorage.setItem("popstate",'false')
		this.firstTime = false;
	}else{
		if(localStorage.getItem("paginaActual") == '1'){
			pagina = localStorage.getItem("paginaActual")
			console.log('seteando pagina malditoa2',pagina)
			this.firstTime = false;
			localStorage.setItem("paginaActual",'2')
		}else{
			this.feedProductos.paginaActual++
			pagina = this.feedProductos.paginaActual

			console.log('seteando pagina malditoa3',pagina)
			localStorage.setItem("paginaActual",pagina)
		}
	}
	
	if(localStorage.getItem('paginaActualDetalleProducto')){

		pagina = parseInt(localStorage.getItem('paginaActualDetalleProducto'));
		pagina++
		console.log('seteando pagina malditoa4',pagina)
		this.feedProductos.paginaActual = pagina 
		localStorage.setItem("paginaActual",pagina)
		localStorage.removeItem('paginaActualDetalleProducto')
	}

	if(!pagina){
		pagina = 1;
		localStorage.setItem("paginaActual",pagina)
	}
	console.log("pagina que va a consultar",pagina)
	this.productoService.productoListado({
		pagina_actual: pagina,
		busqueda: this.formSearch.controls.busqueda.value,
		categoria: this.globals.configuracion.front.listado.categoria,
		marca: this.globals.configuracion.front.listado.marca,
		modelo: this.globals.configuracion.front.listado.modelo,
		ordenar: this.globals.configuracion.front.listado.ordenar_new,
		ordenar_modo: this.globals.configuracion.front.listado.ordenar_modo,
		typeabbrev: this.globals.configuracion.front.typeabbrev,
		modelos: this.globals.configuracion.front.listado.modelos,
		tags: this.globals.configuracion.front.listado.tags,
		tag: this.globals.configuracion.front.listado.tag,
    }).subscribe(
		resultado =>{
			if( !resultado.error ){
				// localStorage.setItem("paginaActual",""+(this.feedProductos.paginaActual)) 
				
				if(localStorage.getItem('despues_de_agregar') != null && localStorage.getItem('despues_de_agregar') == 'true' && localStorage.getItem('descripcion') != null){
					
					
					// window.scrollTo(0,parseInt(localStorage.getItem('positionY'))/parseInt(localStorage.getItem('paginaActual'))-1)
					let pro = JSON.parse(localStorage.getItem('producto'))
					// console.log('pro',pro)
					const scrollPosition = JSON.parse(localStorage.getItem('scrollPosition'));
					const ultmos_productos = JSON.parse(localStorage.getItem('ultimos_productos'));
					if (scrollPosition) {
						// Restaurar la posición del scroll
						if(ultmos_productos){
							
							this.feedProductos.productos = ultmos_productos;
							// Array.prototype.push.apply( this.feedProductos.productos, ultmos_productos );

							this.globals.feedProductos.productos = ultmos_productos;
							this.cargoListaAnterior = true
							// console.log('this.feedProductos.productos',this.feedProductos.productos)
						}
						window.scrollTo(scrollPosition.x, scrollPosition.y);
						// Limpiar la posición del scroll del localStorage
  						localStorage.removeItem('scrollPosition');
  						localStorage.removeItem('ultimos_productos');
					
					}
					// document.querySelector("tuSelector:contains('"+localStorage.getItem('descripcion')+"')").scrollIntoView();
					localStorage.setItem('despues_de_agregar','false')
				}
				// console.log('this.cargoListaAnterior',this.cargoListaAnterior)
				if(!this.cargoListaAnterior){
					if(pagina == 1){
						this.feedProductos.productos = resultado.registros;
						this.globals.feedProductos.productos = resultado.registros;
					}else{

						Array.prototype.push.apply( this.feedProductos.productos, resultado.registros );
						this.globals.feedProductos.productos = this.feedProductos.productos;
					}
				}
				this.cargoListaAnterior = false;
				
				this.feedProductos.cargando = false;
				//en la primera pagina sube el scroll
				if(this.feedProductos.paginaActual == 2){
					// console.log("sube el scroll hasta arriba")
					// window.scrollTo(0, 0);
				}
			}else{
				console.log("Error",resultado.mensaje);
			}

		},
		error =>{
			console.log("Error",error);
			//this.feedProductos.cargando = false;
		}
	)
  }
  centerElement(selector) {
	const element = document.getElementById(selector);
	if (element) {
	  const rect = element.getBoundingClientRect();
	  const elementPositionY = rect.top + window.pageYOffset;
	
	  window.scrollTo({
		top: elementPositionY,
		behavior: 'smooth'
	  });
	} else {
	  console.error('Element not found');
	}
  }
  
  
  downloadPDF: any = {
	cargando: false
  }
  productosListadoPDF(){
    this.downloadPDF.cargando = true;
	this.productoService.productoListadoPDF({
		pagina_actual: 1,
		registros_por_pagina: 280,
		busqueda: this.formSearch.controls.busqueda.value,
		categoria: this.globals.configuracion.front.listado.categoria,
		marca: this.globals.configuracion.front.listado.marca,
		modelo: this.globals.configuracion.front.listado.modelo,
		ordenar: this.globals.configuracion.front.listado.ordenar_new,
		ordenar_modo: this.globals.configuracion.front.listado.ordenar_modo,
		typeabbrev: this.globals.configuracion.front.typeabbrev,
		modelos: this.globals.configuracion.front.listado.modelos,
		tags: this.globals.configuracion.front.listado.tags,
		tag: this.globals.configuracion.front.listado.tag,
		tag_descripcion: this.globals.configuracion.front.listado.tag_descripcion,
	}).subscribe(
		resultado =>{
			window.open( this.globals.configuracion.rootApiRestFull + resultado.file );
			this.downloadPDF.cargando = false;
		},
		error =>{
			console.log("Error",error);
			this.downloadPDF.cargando = false;
		}
	)
  }

  onScroll(){
	
	if( this.feedProductos.productos.length > 0 ){
		
		this.productosListado();
	}
  }

  detalleProducto( producto ){
	
	this.globals.configuracion.modalproducto = producto;
	localStorage.setItem('producto',JSON.stringify(producto));
	
	localStorage.setItem('ultimos_productos',JSON.stringify(this.feedProductos.productos));
	
	localStorage.setItem('scrollPosition', JSON.stringify({
		x: window.pageXOffset,
		y: window.pageYOffset
	}));

	localStorage.setItem('paginaActualDetalleProducto',localStorage.getItem("paginaActual"))

	this.router.navigate(['producto']);

  }

  filtroModelos(){
	const dialogRef = this.dialog.open(ModalFiltroModelosComponent);

    dialogRef.afterClosed().subscribe(result => {
      if( result ){
		this.globals.configuracion.front.listado.modelos = result;
		this.globals.setDataFront();

		this.search();
	  }
    });
  }

  filtroTags(){
	const dialogRef = this.dialog.open(ModalFiltroTagsComponent);

    dialogRef.afterClosed().subscribe(result => {
      if( result ){
		this.formSearch.controls.busqueda.setValue("");
		this.globals.configuracion.front.listado.tag = result.idmodelo;
		this.globals.configuracion.front.listado.tag_descripcion = result.marca_modelo;

		this.search();
	  }
    });
  }

  copiarBusqueda(){
	var
		host = window.location.hostname,
		busqueda = encodeURIComponent( this.formSearch.controls.busqueda.value ),
		ordenar = this.globals.configuracion.front.listado.ordenar_new,
		ordenar_modo = this.globals.configuracion.front.listado.ordenar_modo,
		puerto = "",
		vendedor = "",
		modoPrecio = "";

	if( window.location.port != "" ){
		puerto = ":" + window.location.port;
	}
	if( this.globals.configuracion.front.vendedor != "" ){
		vendedor = "/" + this.globals.configuracion.front.vendedor;
	}
	if( this.globals.configuracion.front.typeabbrev == "01" ){
		modoPrecio = "detal";
	}else{
		modoPrecio = "mayor";
	}
	
	this.clipboard.copy( host + puerto + '/busqueda/' + busqueda + '/' + ordenar + '/' + ordenar_modo + '/' + modoPrecio + vendedor );

	this.snackBar.open(`Búsqueda copiada al portapapeles`, ' ', {
		dismiss: true
	});
  }

  masTags(e){
	e.preventDefault();
	e.stopPropagation();
  }

  ngOnInit(): void {
	// this.activatedRoute.queryParams.subscribe(params => {
	
	// console.log("DONDE ES QUE ESTAS ENTRANDO TU PUES")


	
			
		

	// 	}else{
		// });
		console.log("ENTRANDO EN SCROLLPOSITION")

			this.firstTime = true;
			this.activatedRoute.queryParams.subscribe(params => {
				// alert(JSON.stringify(params));
				if (params.vendedor != null) {
					this.globals.configuracion.front.vendedor = params.vendedor;
				}
				if (params.modoPrecio != null) {
					this.globals.configuracion.front.listado.tag = "";
					this.globals.configuracion.front.listado.tag_descripcion = "";
					if (params.modoPrecio == "mayor") {
						this.globals.configuracion.front.typeabbrev = "02";
					}
					if (params.modoPrecio == "detal") {
						this.globals.configuracion.front.typeabbrev = "01";
					}
				}
				if (params.busqueda != null || params.value != null) {
				
					this.globals.configuracion.front.listado.busqueda = params.busqueda ?? params.value;
					this.formSearch.controls.busqueda.setValue( params.busqueda  ?? params.value);
				}
				
				if(!params.ordenar){
					this.globals.configuracion.front.listado.ordenar_new = 'reciente';
				}
				if (params.ordenar != null) {
					this.globals.configuracion.front.listado.ordenar_new = params.ordenar;
				}
				if (params.ordenar_modo != null) {
					this.globals.configuracion.front.listado.ordenar_modo = params.ordenar_modo;
				}
				const ordenar = params['ordenar_new'];
				const ordenar_modo = params['ordenar_modo'];
				const buscar = params['buscar'];
				// alert("sin entrar nada")
				// console.log(params)
				if(params['ordenar_new'] && params['ordenar_modo']){
					// alert("?ordenar")
					this.ordenarListado(ordenar,ordenar_modo)
				}
				if(params['categoria']){
					this.globals.configuracion.front.listado.categoria = params['categoria']
				}
				if((params['buscar'] == 'true' || params['buscar'] == '') && params['tag'] && !params['value']){
					
					this.globals.configuracion.front.listado.modelo = params['tag'];
					this.globals.configuracion.front.listado.tag_descripcion = params['tag_descripcion'] ?? "";
					this.globals.configuracion.front.listado.tag = params['tag'] ?? "";

				}
			
				if(params['value']){
					this.globals.configuracion.front.listado.busqueda = params['value'];
					
				}
				if(typeof params['pagina'] !== 'undefined'){
					localStorage.setItem('paginaActual','1')
				}
				if(params['pagina']){
					localStorage.setItem('paginaActual',params['pagina'])
				}
				/*
				if ( this.globals.configuracion.front.listado.ordenar_new == undefined ) {
					this.globals.configuracion.front.listado.ordenar_new = 'reciente';
				}
				*/
				this.params = params;
				/*
				this.globals.setDataFront();

				this.feedProductos.paginaActual = 1;
				this.feedProductos.productos.splice( 0 );
				this.productosListado();
				*/
				
				console.log("ENTRANDO EN SEARCH PRODUCTOS")
					const scrollPosition = JSON.parse(localStorage.getItem('scrollPosition'));
				const ultmos_productos = JSON.parse(localStorage.getItem('ultimos_productos'));
				
				if (scrollPosition) {
					console.log("ENTRANDO EN SCROLLPOSITION")
					this.feedProductos.cargando = false;

					// Restaurar la posición del scroll
					if(ultmos_productos){
						
						this.feedProductos.productos = ultmos_productos;
						// Array.prototype.push.apply( this.feedProductos.productos, ultmos_productos );

						this.globals.feedProductos.productos = ultmos_productos;
						this.cargoListaAnterior = true
						// console.log('this.feedProductos.productos',this.feedProductos.productos)
					}
					setTimeout( function(){
						
						window.scrollTo(scrollPosition.x, scrollPosition.y);
						console.log("YA SE MOVIO")
					},1000)
					
					// Limpiar la posición del scroll del localStorage
					localStorage.removeItem('scrollPosition');
					localStorage.removeItem('ultimos_productos');
					localStorage.setItem('despues_de_agregar','false')

					
					this.feedProductos.paginaActual++
					let pagina = this.feedProductos.paginaActual
					localStorage.setItem("paginaActual",`${pagina}`)

					
					this.cargoListaAnterior = false;
				}else{

					this.search();
				}
				

			})
		// }

  }

}
